import { describe, it, expect } from "vitest";
import { checkRealFuncChar } from "./symbol_utils";

describe("symbol_utils", () => {
  describe("checkRealFuncChar", () => {
    it("应该找到简单函数声明的正确位置", () => {
      const rawLine = "function testFunction() { return true; }";
      const result = checkRealFuncChar(
        rawLine,
        0,
        9, // 原始位置
        "testFunction",
        12, // Function kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 9,
      });
    });

    it("应该处理箭头函数声明", () => {
      const rawLine = 'const arrowFunc = () => { console.log("test"); }';
      const result = checkRealFuncChar(
        rawLine,
        0,
        6, // 原始位置
        "arrowFunc",
        12, // Function kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 6,
      });
    });

    it("应该处理类方法声明", () => {
      const rawLine = "  public methodName(param: string): void {";
      const result = checkRealFuncChar(
        rawLine,
        5,
        9, // 原始位置
        "methodName",
        6, // Method kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 5,
        character: 9,
      });
    });

    it("应该处理多行声明", () => {
      const rawLine = `/**
 * 这是一个测试函数
 */
function multiLineFunction() {
  return "test";
}`;
      const result = checkRealFuncChar(
        rawLine,
        0,
        0, // 原始位置
        "multiLineFunction",
        12, // Function kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 3,
        character: 9,
      });
    });

    it("应该处理包含特殊字符的函数名", () => {
      const rawLine = "function $special_Function$() { return true; }";
      const result = checkRealFuncChar(
        rawLine,
        0,
        9, // 原始位置
        "$special_Function$",
        12, // Function kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 9,
      });
    });

    it("应该处理正则表达式特殊字符", () => {
      const rawLine = "function test.function() { return true; }";
      const result = checkRealFuncChar(
        rawLine,
        0,
        9, // 原始位置
        "test.function",
        12, // Function kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 9,
      });
    });

    it("应该处理变量名包含函数名的情况", () => {
      const rawLine = "const testFunctionVar = testFunction();";
      const result = checkRealFuncChar(
        rawLine,
        0,
        6, // 原始位置
        "testFunction",
        12, // Function kind
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 24,
      });
    });

    it("应该处理空字符串输入", () => {
      const rawLine = "";
      const result = checkRealFuncChar(
        rawLine,
        0,
        0,
        "testFunction",
        12,
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 0,
      });
    });

    it("应该处理不匹配的函数名", () => {
      const rawLine = "function otherFunction() { return true; }";
      const result = checkRealFuncChar(
        rawLine,
        0,
        9,
        "nonExistentFunction",
        12,
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 9,
      });
    });

    it("应该处理 TypeScript 泛型函数", () => {
      const rawLine =
        "function genericFunction<T>(param: T): T { return param; }";
      const result = checkRealFuncChar(
        rawLine,
        0,
        9,
        "genericFunction",
        12,
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 9,
      });
    });

    it("应该处理异步函数声明", () => {
      const rawLine = "async function asyncFunction(): Promise<void> {";
      const result = checkRealFuncChar(
        rawLine,
        0,
        15, // async function 后的位置
        "asyncFunction",
        12,
        "file:///test.ts",
      );

      expect(result).toEqual({
        line: 0,
        character: 15,
      });
    });
  });
});
